import { addCpfMask, generateAvatarInitialsImage } from '@repo/ui';
import { GET_PAGINATED_ORGANIZATION_STUDENTS_WITHOUT_TCE_COLUMNS } from 'domain/models';
import { GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

export const makeStudentsWithoutTceColumns = (): TableColumn<
  GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Result['students'][number]
>[] => {
  return [
    {
      name: 'Estudante',
      sortable: true,
      sortField: GET_PAGINATED_ORGANIZATION_STUDENTS_WITHOUT_TCE_COLUMNS.NAME,
      wrap: true,
      selector: (row) => row.name,
      cell: ({ photo, name, cpf }) => (
        <div className="d-flex align-items-center gap-2">
          <img
            src={photo || generateAvatarInitialsImage(name)}
            className="rounded-circle avatar-xs user-profile-image"
          />
          <div>
            <p className="m-0">{name}</p>
            <p className="m-0 text-muted">{addCpfMask(cpf)}</p>
          </div>
        </div>
      ),
    },
    {
      name: 'Grupo',
      selector: (row) => row.groupName,
      sortField:
        GET_PAGINATED_ORGANIZATION_STUDENTS_WITHOUT_TCE_COLUMNS.GROUP_NAME,
      wrap: true,
      sortable: true,
      cell: ({ groupName, groupCode }) => `${groupName} - ${groupCode}`,
    },
  ];
};
